export interface ClientOverview {
  lot: {
    id: string;
    name: string;
    address: string | null;
    city: string | null;
    state: string | null;
    timezone: string;
    vacancies: number | null;
    createdAt: string;
    archivedAt: string | null;
    subscription: {
      status: string | null;
      trialEndsAt: string | null;
      billingCycle: string | null;
      ticketBlockAt: string | null;
    };
  };
  owners: Array<{ name: string; email: string; lastLoginAt: string | null }>;
  modules: Array<{ key: string; status: string; trialEndsAt: string | null }>;
  usage: {
    openNow: number;
    opened: { today: number; last7: number; last30: number };
    closed: { today: number; last7: number; last30: number };
    valetLast30: number;
    monthlySubscribers: number;
    partners: number;
    revenueLast30Cents: number;
    averageTicketLast30Cents: number;
    daily: Array<{ date: string; opened: number }>;
  };
  setup: Array<{ key: string; label: string; done: boolean }>;
  problems: Array<{ key: string; label: string; count: number; lastAt: string | null }>;
  activity: Array<{
    action: string;
    entity: string;
    actorType: string;
    actorEmail: string | null;
    at: string;
  }>;
  team: Array<{ name: string; role: string; active: boolean; lastSeenAt: string | null }>;
  location: { lat: number; lng: number; precision: 'address' | 'city' } | null;
}

export const when = (iso: string | null) =>
  iso ? new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : 'nunca';

export const day = (iso: string | null) =>
  iso ? new Date(iso).toLocaleDateString('pt-BR', { dateStyle: 'short' }) : '-';
